import React, { Component } from 'react';
import "./style/gym.css";
import "./style/bootstrap.css";
import "./style/loading.scss";

class App extends Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default App;
